import type { GoogleTagManagerItem } from "@/features/analytics/models";
import type { CheckoutDiscount } from "@/features/payments/api";
import type { CategoryWithSelectedProduct } from "@/features/products/models";

export const categoriesToGoogleTagManagerProducts = (
  categories: CategoryWithSelectedProduct[],
  checkoutDiscount?: CheckoutDiscount,
): GoogleTagManagerItem[] =>
  categories.map((category) => {
    const discount = checkoutDiscount?.prices.find(
      (price) =>
        price.subscriptionPriceId ===
        category.selectedProduct?.selectedPrice?.subscriptionPriceId,
    )?.discount;

    return {
      item_id:
        category.selectedProduct?.selectedPrice?.subscriptionPriceId ?? "",
      item_name: category.selectedProduct?.name ?? "",
      item_brand: "LevelsRx",
      item_category: `${category.selectedProduct?.selectedPrice?.durationInMonths} months`,
      price: category.selectedProduct?.selectedPrice?.price ?? 0,
      quantity: 1,
      discount: discount?.isValid
        ? (category.selectedProduct?.selectedPrice?.price ?? 0) -
          discount.priceAfterDiscount
        : undefined,
      coupon: checkoutDiscount?.code,
    };
  });
